const devProjects = [
  {
    title: "IP",
    subtitle: "Go",
    tags: ['Computer Networks', 'Go', 'Docker'],
    description:
      "An RFC-compliant virtual Internet Protocol (IP) network with packet forwarding and dynamic routing.",
    image: "ip/ip.png",
    link: "/ip",
  },
  {
    title: "Syntax",
    subtitle: "React, Chakra UI, TypeScript, Java",
    tags: ['React', 'Chakra UI', 'Frontend', 'Backend'],
    description:
      "A code racer web app to practice coding faster and learn the syntax of new languages.",
    image: "syntax/syntax-mockup-side.png",
    link: "/syntax",
  },
  {
    title: "Shell",
    subtitle: "C",
    tags: ['Systems', 'Linux', 'C'],
    description:
      "A mock Linux shell that handles common terminal commands and job / signal handling.",
    image: "shell/shell.png",
    link: "/shell",
  },
  {
    title: "Ghiblify",
    subtitle: "Pytorch, Python",
    tags: ['Deep Learning', 'Pytorch', 'VGG19'],
    description:
      "A style transfer model that applies the style of a Studio Ghibli movie to any image.",
    image: "ghiblify/ghiblify.png",
    link: "/ghiblify",
  },
  {
    title: "Jamz Findz",
    subtitle: "React, HTML, CSS",
    tags: ['React', 'HTML', 'CSS', 'Frontend'],
    description:
      "Designing and Developing a website to browse Spotify's newest releases",
    image: "jamz/jamz-mockup.png",
    link: "/jamz-findz",
  },
  {
      title: "SpeechMe",
      subtitle: "Swift, Python",
      tags: ['Swift', 'Frontend', 'Mobile Dev'],
      description:
        "A mobile app to practice speech, built for those with speech impediments.",
      image: "speech-me/speech-me-mockup.png",
      link: "/speech-me",
  },
];

const designProjects = [
  {
    title: "Responsive Redesign",
    subtitle: "HTML, CSS, and JS",
    tags: ['HTML', 'CSS', 'JS', 'Redesign'],
    description:
      "Responsive redesign of a local bagel restaurant's website. Built with HTML, CSS, and JavaScript.",
    image: "redesign/redesign-mockup.png",
    link: "/redesign",
  },
  {
      title: "Hello",
      subtitle: "Figma",
      tags: ['Figma', 'Iterative Design'],
      description:
        "Iterative design project for Hello, a startup search engine for developers.",
      image: "hello/hello-mockup.png",
      link: "/hello",
  },
  {
    title: "Personas & Storyboard",
    subtitle: "UX Research",
    tags: ['UX research', 'Design Process'],
    description:
      "UX research project on the users of Coca Cola drink dispenser at Brown",
    image: "personas/personas.png",
    link: "/personas",
  },
];

export const projectSections = [
  {
    "title": "projects/dev",
    "projects": devProjects,
  },
  {
    "title": "projects/design",
    "projects": designProjects,
  },
]